module.exports = __webpack_public_path__ + "img/folder-alt.54a6cd7f.svg";